import React, { createContext, useState } from "react";

const QuestionnaireContext = createContext();

const QuestionnaireProvider = ({ children }) => {
  const [currentSubSectionId, setCurrentSubSectionId] = useState(0);
  const [currentSectionId, setCurrentSectionId] = useState(0);
  const [currentPqId, setCurrentPqId] = useState(0);
  return (
    <QuestionnaireContext.Provider
      value={{ currentSubSectionId, setCurrentSubSectionId, currentSectionId, setCurrentSectionId, currentPqId, setCurrentPqId }}
    >
      {children}
    </QuestionnaireContext.Provider>
  );
};

export { QuestionnaireContext, QuestionnaireProvider };
